import { Button, Text } from '@kanda-libs/ks-design-library';

interface DisabledEmailPopoverProps {
  onClose: () => void;
}

const DisabledEmailPopover: React.FunctionComponent<DisabledEmailPopoverProps> =
  function ({ onClose }) {
    return (
      <div className="mx-4 my-5 min-w-60 relative">
        <div className="mb-2">
          <Text
            text="Need to change email?"
            className="text-12-18-em text-neutral-900"
          />
        </div>
        <Text
          text="Ask your tradesperson to send the job to the email address you'd like to apply with."
          className="text-12-18 text-neutral-600"
        />
        <Button.Icon
          id="disabled-email-popover-close"
          icon="close"
          className="absolute -top-4 -right-3 text-neutral-600 cursor-pointer"
          iconProps={{
            className: 'w-4',
          }}
          onClick={onClose}
        />
      </div>
    );
  };

export default DisabledEmailPopover;
